import { render } from "./ModalObservaciones.vue?vue&type=template&id=4e9562cc&ts=true"
import script from "./ModalObservaciones.vue?vue&type=script&lang=ts"
export * from "./ModalObservaciones.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\wamp64\\www\\sisdeu\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__